import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, Button, Box } from "@mui/material";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./CalendarStyles.css";
import MDTypography from "../../components/MDTypography";
import GenericTable from "../genericTable";
import { createMRTColumnHelper } from "material-react-table";
import dayjs from "dayjs";
import apiService from "../../services/api-service";
import showToast from "../../utils/toast";

function HoursDateCopy({ open, onClose, onCopyHours }) {
	const [selectedDate, setSelectedDate] = useState(new Date());
	const [hoursData, setHoursData] = useState([]);
	const columnHelper = createMRTColumnHelper();

	const tileDisabled = ({ date }) => {
		const today = new Date();
		return date > today;
	};

	const handleDateChange = (newDate) => {
		setSelectedDate(newDate);
		apiService
			.get(
				"/activity-management/",
				{
					id_area: localStorage.getItem("areaSelected"),
					date: dayjs(newDate).format("YYYY-MM-DD"),
					from_appeal_journal_screen: false,
					get_all_hours: true,
				},
				{}
			)
			.then((data) => {
				console.log("Hours data from selected date:", data);
				const transformedData = data.map((item) => ({
					...item,
					selected: true,
				}));
				setHoursData(transformedData);
			})
			.catch((error) => {
				showToast("Errore durante il caricamento dei dati ore. Riprova più tardi.", "error");
			});
	};

	const columns = [
		columnHelper.accessor("name", {
			header: "Nome - Cognome",
			size: 250,
			Cell: ({ row }) => (
				<MDTypography variant="caption" fontWeight="medium">
					{row.original.name}
				</MDTypography>
			),
		}),
		columnHelper.accessor("supplier_name", {
			header: "Fornitore",
			size: 200,
			Cell: ({ row }) => <MDTypography variant="caption">{row.original.supplier_name || "Interno"}</MDTypography>,
		}),
		columnHelper.accessor("hours_to_insert", {
			header: "Ore da inserire",
			size: 150,
			Cell: ({ row }) => <MDTypography variant="caption">{row.original.hours_to_insert}</MDTypography>,
		}),
	];

	const handleCopy = () => {
		const selectedHours = hoursData.filter((item) => item.selected);
		onCopyHours(selectedHours);
		onClose();
	};

	return (
		<Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
			<DialogTitle>
				<MDTypography variant="h6">Copia suddivisione ore da data precedente</MDTypography>
			</DialogTitle>
			<DialogContent>
				<Box sx={{ display: "flex", flexDirection: "column", gap: 2, alignItems: "center", my: 2 }}>
					<Calendar onChange={handleDateChange} value={selectedDate} tileDisabled={tileDisabled} maxDate={new Date()} className="custom-calendar" />

					<MDTypography fontWeight="bold" textTransform="uppercase">
						Data selezionata:
						<br />
						{selectedDate.toLocaleDateString("it-IT", {
							weekday: "long",
							year: "numeric",
							month: "2-digit",
							day: "2-digit",
						})}
					</MDTypography>

					{hoursData.length > 0 && (
						<>
							<GenericTable
								data={hoursData}
								columns={columns}
								enableRowSelection={true}
								enableColumnFilters={false}
								enableGlobalFilter={true}
								enablePagination={true}
								disableButton={true}
								initialSelectedAll={true}
								onRowSelectionChange={(selectedRows) => {
									const updatedHoursData = hoursData.map((item) => ({
										...item,
										selected: selectedRows.some((row) => row.id === item.id),
									}));
									setHoursData(updatedHoursData);
								}}
							/>

							<Button
								variant="contained"
								color="primary"
								onClick={handleCopy}
								sx={{
									backgroundColor: "#514f4f",
									color: "white!important",
									width: "220px",
									height: "50px",
									fontSize: "16px",
								}}
							>
								Copia ore selezionate
							</Button>
						</>
					)}
				</Box>
			</DialogContent>
		</Dialog>
	);
}

export default HoursDateCopy;
